import mutations from './mutations'
import state from './state'
import gettersUniqueCode from '@/store/modules/UniqueKey/getters'
import apiCashMov from '@/services/API/CashMov'

const setDate = function({ commit }, datePayLoad) {
    commit('SET_DATE', datePayLoad)
}

const setCashAmount = function({ commit }, cashAmountPayLoad) {
    if (parseInt(cashAmountPayLoad) % 10 === 0) {
        commit('SET_CASH_AMOUNT', cashAmountPayLoad)
    } else {
        commit('SET_CASH_AMOUNT', null)
    }
}

const setComment = function({ commit }, commentPayLoad) {
    commit('SET_COMMENT', commentPayLoad)
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

const setArqueoData = function({ commit }, data) {
    commit('SET_ARQUEO_DATA', data)
}

const setInitialSummaries = function({ commit }, data) {
    commit('SET_INITIAL_SUMMARIES', data)
}

const setInvoicesData = function({ commit }, data) {
    commit('SET_INVOICES_DATA', data)
}

const fetchDailyInvoices = async function({}, cashDesk) {
    return apiCashMov.dailyInvoices(cashDesk)
}

const closeCash = async function({ state, rootState }, authCodeSupervisor) {
    let userID = rootState.AuthModule.user.id
    let cashDeskID = rootState.AuthModule.cash_desk_id
    let response = await apiCashMov.posDailyCashClose(
        cashDeskID,
        userID,
        authCodeSupervisor,
        parseInt(state.cashAmount),
        state.comment
    )
    return response
}

const printReceip = async function(
    { rootState, rootGetters },
    { idMovCaja, supervisor = null }
) {
    let win = window.open('../cashClose.html')
    win.window.title = 'CIERRE DE CAJA'
    win.window.subtitle = `DOCN°${DOCNum(idMovCaja)}`

    // fecha y hora de cierre de caja:
    win.window.date = getDate()
    win.window.time = getTime()

    win.window.amount = parseInt(state.cashAmount)
    win.window.comment = state.comment
    win.window.cashDesk = rootState.AuthModule.cash_desk_id
    win.window.preventPrint = rootState.SessionModule.preventPrint
    win.window.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

    // Pasandole datos de arqueo:
    // win.window.openingUser = state.initialSummaries.opening_user
    const fullName = ({ names, last_name1 }) => `${names} ${last_name1}`
    win.window.openingUser =
        rootState.AuthModule.user.name_case ||
        fullName(rootState.AuthModule.user.hr_employee)
    win.window.openingTimeStamp = state.initialSummaries.opening_timestamp
    win.window.initialAmountCash = state.initialSummaries.initial_amount_cash

    win.window.totalCustomerSummaries = state.arqueoData.customerTotal
    win.window.detailCustomerSummaries = state.arqueoData.customer

    win.window.totalEmployeeSummaries = state.arqueoData.employeeTotal
    win.window.detailEmployeeSummaries = state.arqueoData.employee
    win.window.totalIncome = state.arqueoData.income
    win.window.detailEgressSummaries = state.arqueoData.egress

    // DATOS FACTURAS:
    win.window.detailInvoices = state.invoicesData

    //Info Sucursal
    win.window.officeID = rootGetters['AuthModule/branchOfficeID']
    win.window.officeName = rootGetters['AuthModule/branchOfficeName']
    win.window.cashDesk = rootGetters['AuthModule/cashDeskID']

    if (supervisor) {
        win.window.supervisorName = supervisor.name // después recibir de algún otro store
        win.window.supervisorID = supervisor.id // después recibir de algún otro store
    }

    return true
}

const DOCNum = function(idMovCaja) {
    // después pasar esto a un mixin o utils
    idMovCaja = idMovCaja.toString()
    // console.log('largo: ', idMovCaja.length)
    let zerosString = ''
    for (let i = 0; i < 12 - idMovCaja.length; i++) {
        zerosString = zerosString.concat('0')
    }
    return zerosString.concat(idMovCaja)
}

const getDate = function() {
    // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
    let date = new Date()

    let year = date.getFullYear()

    let month = date.getMonth() + 1
    if (month < 10) {
        month = `0${month}`
    } else {
        month = `${month}`
    }

    let day = date.getDate()
    if (day < 10) {
        day = `0${day}`
    } else {
        day = `${day}`
    }

    return `${day}/${month}/${year}`
}

const getTime = function() {
    // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
    let date = new Date()

    let hours = date.getHours()
    if (hours < 10) {
        hours = `0${hours}`
    } else {
        hours = `${hours}`
    }

    let minutes = date.getMinutes()
    if (minutes < 10) {
        minutes = `0${minutes}`
    } else {
        minutes = `${minutes}`
    }

    let seconds = date.getSeconds()
    if (seconds < 10) {
        seconds = `0${seconds}`
    } else {
        seconds = `${seconds}`
    }
    return `${hours}:${minutes}:${seconds}`
}

export default {
    setDate,
    setCashAmount,
    setComment,
    fetchDailyInvoices,
    resetState,
    closeCash,
    printReceip,
    setArqueoData,
    setInvoicesData,
    setInitialSummaries,
}
